module.exports = __webpack_public_path__ + "assets/d243b30de0a8ec1e7bc3b63941206b34.png";